module.exports = __webpack_public_path__ + "img/image169.fde89cdd.jpg";